import styled from 'styled-components';
import { Form } from 'UI';

export const SItem = styled(Form.Item)<{
  width?: string;
}>`
  margin-bottom: 30px;
  width: ${({ width }) => `${width}`};
`;
